const SAUDI_REDBULL_MOBILE = /^5(74|75)\d{6}$/;

export function isSaudiRedBullMobile(significant) {
	return SAUDI_REDBULL_MOBILE.test(significant || '');
}

export function resolvePhoneValidity({ number, isValid, country }) {
	if (isValid) {
		return true;
	}

	const iso2 = country?.iso2 || country?.iso || '';
	if (iso2 !== 'SA') {
		return false;
	}

	return isSaudiRedBullMobile(number?.significant);
}
